import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';

export default function KargoYonetimi() {
  const { profil } = useAuth();
  const [firmalar, setFirmalar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ ad: '', kod: '', api_url: '', kullanici_adi: '', sifre: '', go_kullanici: '', go_sifre: '', ao_kullanici: '', ao_sifre: '', musteri_kodu: '', varsayilan: false, aktif: true });
  const [duzenle, setDuzenle] = useState(null);
  const [loglari, setLoglari] = useState([]);
  const [tab, setTab] = useState('firmalar');

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    const [{ data: f }, { data: l }] = await Promise.all([
      supabase.from('kargo_firmalari').select('*').order('ad'),
      supabase.from('kargo_loglari')
        .select('*, siparisler(siparis_no), kullanicilar(ad, soyad), kargo_firmalari(ad)')
        .order('created_at', { ascending: false })
        .limit(50),
    ]);
    setFirmalar(f || []);
    setLoglari(l || []);
    setLoading(false);
  }

  function yeniAc() {
    setForm({ ad: '', kod: '', api_url: '', kullanici_adi: '', sifre: '', musteri_kodu: '', varsayilan: false, aktif: true });
    setDuzenle(null);
    setModal(true);
  }

  function duzenleAc(f) {
    setForm({ ad: f.ad, kod: f.kod, api_url: f.api_url || '', kullanici_adi: f.kullanici_adi || '', sifre: f.sifre || '', go_kullanici: f.go_kullanici || '', go_sifre: f.go_sifre || '', ao_kullanici: f.ao_kullanici || '', ao_sifre: f.ao_sifre || '', musteri_kodu: f.musteri_kodu || '', varsayilan: f.varsayilan, aktif: f.aktif });
    setDuzenle(f.id);
    setModal(true);
  }

  async function handleKaydet() {
    if (!form.ad || !form.kod) return;
    // Varsayılan seçildiyse diğerlerini kapat
    if (form.varsayilan) {
      await supabase.from('kargo_firmalari').update({ varsayilan: false }).neq('id', duzenle || '00000000-0000-0000-0000-000000000000');
    }
    if (duzenle) {
      await supabase.from('kargo_firmalari').update(form).eq('id', duzenle);
    } else {
      await supabase.from('kargo_firmalari').insert(form);
    }
    setModal(false);
    fetchData();
  }

  async function handleSil(id) {
    if (!window.confirm('Bu kargo firmasını silmek istediğinizden emin misiniz?')) return;
    await supabase.from('kargo_firmalari').delete().eq('id', id);
    fetchData();
  }

  async function toggleAktif(f) {
    await supabase.from('kargo_firmalari').update({ aktif: !f.aktif }).eq('id', f.id);
    fetchData();
  }

  const durumRenk = {
    kargoya_verildi: 'badge-blue',
    elden_teslim: 'badge-green',
    teslim_edildi: 'badge-green',
    hata: 'badge-red',
  };

  const durumLabel = {
    kargoya_verildi: '🚚 Kargoya Verildi',
    elden_teslim: '🤝 Elden Teslim',
    teslim_edildi: '✅ Teslim Edildi',
    hata: '❌ Hata',
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Kargo Yönetimi</h1>
          <p className="page-subtitle">{firmalar.length} kargo firması tanımlı</p>
        </div>
        <button className="btn btn-primary" onClick={yeniAc}>+ Kargo Firması Ekle</button>
      </div>

      <div className="tabs" style={{ marginBottom: 16 }}>
        <button className={`tab-btn ${tab === 'firmalar' ? 'active' : ''}`} onClick={() => setTab('firmalar')}>Kargo Firmaları</button>
        <button className={`tab-btn ${tab === 'log' ? 'active' : ''}`} onClick={() => setTab('log')}>İşlem Geçmişi</button>
      </div>

      {tab === 'firmalar' && (
        <>
          {/* API Bilgi Kutusu */}
          <div style={{ background: 'rgba(224,123,0,0.08)', border: '1px solid rgba(224,123,0,0.3)', borderRadius: 'var(--r)', padding: 16, marginBottom: 16 }}>
            <div style={{ fontWeight: 700, color: 'var(--accent)', marginBottom: 8 }}>💡 API Entegrasyonu Hakkında</div>
            <p style={{ fontSize: 13, color: 'var(--text2)', margin: 0 }}>
              Kargo firması API bilgilerini aldığınızda buraya girin. API aktif olmadan sistem manuel takip numarası ile çalışır.
              API aktif olduğunda kargo takip numarası otomatik oluşacak, kargo durumu otomatik güncellenecektir.
            </p>
          </div>

          <div className="card" style={{ padding: 0 }}>
            <table className="table">
              <thead>
                <tr><th>Firma Adı</th><th>Kod</th><th>API Durumu</th><th>Durum</th><th>Varsayılan</th><th>İşlem</th></tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={6} className="loading">Yükleniyor...</td></tr>
                ) : firmalar.length === 0 ? (
                  <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Kargo firması eklenmemiş</td></tr>
                ) : firmalar.map(f => (
                  <tr key={f.id}>
                    <td style={{ fontWeight: 600 }}>{f.ad}</td>
                    <td><span className="mono" style={{ fontSize: 12 }}>{f.kod}</span></td>
                    <td>
                      {f.api_url && f.kullanici_adi
                        ? <span className="badge badge-green">✓ API Tanımlı</span>
                        : <span className="badge badge-gray">Manuel Mod</span>}
                    </td>
                    <td>
                      <span onClick={() => toggleAktif(f)} className={`badge ${f.aktif ? 'badge-green' : 'badge-red'}`} style={{ cursor: 'pointer' }}>
                        {f.aktif ? '✓ Aktif' : '✗ Pasif'}
                      </span>
                    </td>
                    <td>
                      {f.varsayilan ? <span className="badge badge-orange">⭐ Varsayılan</span> : '-'}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="btn btn-ghost btn-sm" onClick={() => duzenleAc(f)}>Düzenle</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleSil(f.id)}>Sil</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {tab === 'log' && (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr><th>Tarih</th><th>Sipariş</th><th>Firma</th><th>İşlem</th><th>Takip No</th><th>İşlemi Yapan</th></tr>
            </thead>
            <tbody>
              {loglari.length === 0 ? (
                <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>İşlem geçmişi yok</td></tr>
              ) : loglari.map(l => (
                <tr key={l.id}>
                  <td style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(l.created_at).toLocaleString('tr-TR')}</td>
                  <td><span className="mono" style={{ color: 'var(--accent)' }}>{l.siparisler?.siparis_no || '-'}</span></td>
                  <td style={{ color: 'var(--text2)' }}>{l.kargo_firmalari?.ad || '-'}</td>
                  <td><span className={`badge ${durumRenk[l.durum] || 'badge-gray'}`}>{durumLabel[l.durum] || l.durum}</span></td>
                  <td><span className="mono" style={{ fontSize: 12 }}>{l.takip_no || '-'}</span></td>
                  <td style={{ color: 'var(--text2)', fontSize: 12 }}>{l.kullanicilar ? `${l.kullanicilar.ad} ${l.kullanicilar.soyad}` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">{duzenle ? 'Kargo Firması Düzenle' : 'Yeni Kargo Firması'}</h3>

            <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r)', padding: 12, marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text2)', marginBottom: 8 }}>TEMEL BİLGİLER</div>
              <div className="form-row cols-2">
                <div className="form-group">
                  <label className="label">Firma Adı *</label>
                  <input className="input" value={form.ad} onChange={e => setForm(f => ({ ...f, ad: e.target.value }))} placeholder="Yurtiçi Kargo" autoFocus />
                </div>
                <div className="form-group">
                  <label className="label">Kod *</label>
                  <input className="input" value={form.kod} onChange={e => setForm(f => ({ ...f, kod: e.target.value.toLowerCase() }))} placeholder="yurtici" />
                </div>
              </div>
              <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
                  <input type="checkbox" checked={form.aktif} onChange={e => setForm(f => ({ ...f, aktif: e.target.checked }))} />
                  Aktif
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
                  <input type="checkbox" checked={form.varsayilan} onChange={e => setForm(f => ({ ...f, varsayilan: e.target.checked }))} />
                  Varsayılan olarak kullan
                </label>
              </div>
            </div>

            <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r)', padding: 12, marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--accent)', marginBottom: 8 }}>
                🔌 API BİLGİLERİ <span style={{ fontWeight: 400, color: 'var(--text2)' }}>(API key alındığında doldurun)</span>
              </div>
              <div className="form-group">
                <label className="label">API URL</label>
                <input className="input" value={form.api_url} onChange={e => setForm(f => ({ ...f, api_url: e.target.value }))} placeholder="https://api.yurtici.com.tr/..." />
              </div>
              <div className="form-row cols-2">
                <div className="form-group">
                  <label className="label">Kullanıcı Adı / API Key</label>
                  <input className="input" value={form.kullanici_adi} onChange={e => setForm(f => ({ ...f, kullanici_adi: e.target.value }))} placeholder="API kullanıcı adı" />
                </div>
                <div className="form-group">
                  <label className="label">Şifre / Secret Key</label>
                  <input className="input" type="password" value={form.sifre} onChange={e => setForm(f => ({ ...f, sifre: e.target.value }))} placeholder="••••••••" />
                </div>
              </div>
              <div className="form-group">
                <label className="label">Müşteri Kodu</label>
                <input className="input" value={form.musteri_kodu} onChange={e => setForm(f => ({ ...f, musteri_kodu: e.target.value }))} placeholder="12345" />
              </div>
            </div>

            <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r)', padding: 12, marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--accent)', marginBottom: 4 }}>🚚 YURTİÇİ KARGO KULLANICI BİLGİLERİ</div>
              <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 10 }}>GÖ = Gönderici Ödemeli &nbsp;|&nbsp; AÖ = Alıcı Ödemeli</div>
              <div className="form-row cols-2">
                <div className="form-group">
                  <label className="label">GÖ Kullanıcı Adı</label>
                  <input className="input" value={form.go_kullanici} onChange={e => setForm(f => ({ ...f, go_kullanici: e.target.value }))} placeholder="6020G1162204617" />
                </div>
                <div className="form-group">
                  <label className="label">GÖ Şifre</label>
                  <input className="input" type="password" value={form.go_sifre} onChange={e => setForm(f => ({ ...f, go_sifre: e.target.value }))} placeholder="••••••••" />
                </div>
              </div>
              <div className="form-row cols-2">
                <div className="form-group">
                  <label className="label">AÖ Kullanıcı Adı</label>
                  <input className="input" value={form.ao_kullanici} onChange={e => setForm(f => ({ ...f, ao_kullanici: e.target.value }))} placeholder="6020A1162204617" />
                </div>
                <div className="form-group">
                  <label className="label">AÖ Şifre</label>
                  <input className="input" type="password" value={form.ao_sifre} onChange={e => setForm(f => ({ ...f, ao_sifre: e.target.value }))} placeholder="••••••••" />
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleKaydet} disabled={!form.ad || !form.kod}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
